__turbopack_context__.v({
  "blue": "OffersSection-module-scss-module__8-thUa__blue",
  "cardWrapper": "OffersSection-module-scss-module__8-thUa__cardWrapper",
  "container": "OffersSection-module-scss-module__8-thUa__container",
  "fade-in-up": "OffersSection-module-scss-module__8-thUa__fade-in-up",
  "green": "OffersSection-module-scss-module__8-thUa__green",
  "iconWrapper": "OffersSection-module-scss-module__8-thUa__iconWrapper",
  "introColumn": "OffersSection-module-scss-module__8-thUa__introColumn",
  "offerCard": "OffersSection-module-scss-module__8-thUa__offerCard",
  "orange": "OffersSection-module-scss-module__8-thUa__orange",
  "pink": "OffersSection-module-scss-module__8-thUa__pink",
  "visible": "OffersSection-module-scss-module__8-thUa__visible",
});
